import React, { Component, Fragment } from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import School from "../../../models/School";
import SchoolList from "../../SchoolList";
import {Link} from "react-router-dom";
import {CommandBarButton, MessageBarType} from "office-ui-fabric-react";
import {debounce} from "throttle-debounce";
import PageTitle from "../../PageTitle";
import ApiService from "../../ApiService";
import SchoolFilterControls, {SchoolFilter} from "../../SchoolFilterControls";
import { openFileDownload } from '../../../utils/Utils';
import Actions from '../../../redux/Actions';
import H from "history";

interface ListSchoolsPageProps {
    apiService: ApiService;
    history: H.History;
}

interface ListSchoolsPageState {
    schools?: School[];
    filter: SchoolFilter;
    loading: boolean;
}

class ListSchoolsPage extends Component<ListSchoolsPageProps & DispatchProps ,ListSchoolsPageState> {
    static displayName = ListSchoolsPage.name;

    private readonly debouncedFetchSchools: debounce<() => void>;

    constructor(props: ListSchoolsPageProps & DispatchProps) {
        super(props);

        this.debouncedFetchSchools = debounce(200,this.fetchSchools);

        this.state = {
            schools: undefined,
            filter: {filterString: "",showDisabled: false,showExpired: true,showOnlyThirdPartySds: false,licenses: [],onboardStatuses: []},
            loading: false
        }
    }

    async componentDidMount() {
        await this.fetchSchools();
    }

    async componentDidUpdate(prevProps: Readonly<ListSchoolsPageProps & DispatchProps>, prevState: ListSchoolsPageState): Promise<void> {
        
        if(this.state.filter.filterString !== prevState.filter.filterString && this.state.schools)
        {
            this.debouncedFetchSchools();
        }
        else
        {
            if(this.state.filter !== prevState.filter)
            {
                await this.fetchSchools();
            }
        }
        
    }
    
    private async fetchSchools(): Promise<void> {
        this.setState({
            loading: true
        });
        const schools = await this.props.apiService.getSchoolsAdmin(this.state.filter.showDisabled,this.state.filter.showExpired,this.state.filter.showOnlyThirdPartySds,this.state.filter.licenses,this.state.filter.onboardStatuses,this.state.filter.filterString);
        this.setState({
            schools: schools,
            loading: false
        });
    }

    private async downloadSchools() {
        try {
            let result;
           
            result = await this.props.apiService.downloadSchoolsQuery(this.state.filter.showDisabled, this.state.filter.showExpired, this.state.filter.showOnlyThirdPartySds, this.state.filter.licenses, this.state.filter.onboardStatuses, this.state.filter.filterString);

            await openFileDownload(result)

            this.props.dispatch(Actions.showMessageBar(`Downloading Schools`, MessageBarType.success));
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Error downloading Schools. If this problem persists please contact support. ${e.message}`, MessageBarType.error));
        }
    }

    render () {
        
        return(
            <Fragment>
                <PageTitle title={"Schools"}/>
                
                <SchoolFilterControls
                    filter={this.state.filter}
                    onEnterPressed={() => {
                        if(this.state.schools?.length === 1)
                        {
                            const filteredSchool = this.state.schools[0];
                            this.props.history.push(`/cdb-admin/schools/${filteredSchool.tenantId}/${filteredSchool.schoolCode}`);
                        }
                    }}
                    filterChanged={(newFilter) => {
                    this.setState({
                        filter: newFilter
                    });
                }}/>
                <SchoolList schools={this.state.schools || []} title={"Schools"} enableRowLinks={true} loading={this.state.loading}>

                    <Link to="/cdb-admin/schools/new">
                        <CommandBarButton
                            iconProps={{iconName: "add"}}
                            text="Add"
                            onClick={() => { }}
                        />
                    </Link>
                    <CommandBarButton
                        iconProps={{ iconName: "DownloadDocument" }}
                        text="Download"
                        onClick={() => { this.downloadSchools() }}
                    />
                </SchoolList>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {history: H.History}): ListSchoolsPageProps => {
        return {
            history: ownProps.history,
            apiService: state.auth.apiService,
        };
    }
)(ListSchoolsPage)